export const newsupdate=[
   {
      id:1,
      title:"Updated Product",
      para:"I like to be real. I don't like things to be staged or fussy.",
      classname:"activity-dot-primary"

   },
   {
      id:2,
      title:"You liked James products",
      para:"If you have it, you can make anything look good.",
      classname:"activity-dot-primary"
   },
   {
      id:3,
      title:"James just like your product",
      para:"I like to design everything to do with the body.",
      classname:"activity-dot-secondary",
      radiocircle:"fa fa-circle circle-dot-primary"
   },
   {
      id:4,
      title:"Jenna commented on your product",
      para:"Fashion fades, only style remain the same.",
      classname:"activity-dot-primary"
   },
   {
      id:5,
      title:"Jihan Doe just like your product",
      para:"Design and style should work toward making you look good and feel good without lot of effort.",
      classname:"activity-dot-secondary",
      radiocircle:"fa fa-circle circle-dot-secondary"
   }
]